//  Get the current station configuration ListingStatus
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getListingStatus = function(params) {
    return this.axiosIns.get('/api-site/snapshot/listing-status', { params });
};
//  according to listingStatus Get property data 
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getSnapshotListing = function(params) {
    return this.axiosIns.get(`/api-site/snapshot/listings`, { params });
};
// market report  interface 
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getMarketReport = async function(params) {
    // params = Object.keys(params).reduce((prev, cur) => {
    //     const value = params[cur];
    //     if (value === null) return prev;
    //     prev += `&${encodeURIComponent(cur)}=${encodeURIComponent(value)}`;
    //     return prev;
    // }, '');
    if (this.platform.isBot) {
        return {
            data: {
                
            }
        }
    }
    return this.axiosIns.get(`/api-site/snapshot/market-report`, { params });
};
